import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { storeToRefs } from 'pinia';
import { computed, onMounted, watch } from 'vue';
import { i18n } from '@/i18n';
import MultipleSelectInput from '@/corePagesModule/SelectInput/MultipleSelectInput.vue';
import { useGroupListMultipleSelectInputStore } from './useGroupListMultipleSelectInputStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupListMultipleSelectInput',
  props: {
    selectInputIndex: {},
    storeTag: {},
    selectedGroupIdsProp: { default: () => [] as string[] },
    showLabel: { type: Boolean },
    useReset: { type: Boolean, default: true },
    reload: { type: Boolean },
    useTeleport: { type: Boolean }
  },
  emits: ["selectedGroups"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const t = i18n.t;

const store = useGroupListMultipleSelectInputStore(props.storeTag)();
const { state } = storeToRefs(store);

onMounted(() => {
  store.init();
  if (props.selectedGroupIdsProp) {
    state.value.selectedGroupIds = props.selectedGroupIdsProp;
  }
});

watch(
  () => props.selectedGroupIdsProp,
  (newVal) => {
    if (newVal !== undefined) {
      state.value.selectedGroupIds = newVal;
    }
  }
);

watch(
  () => props.reload,
  async (newVal) => {
    if (newVal) {
      await store.reloadGroupData();
    }
  }
);

/**
 * グループ名を選択した際の処理
 * @param indexes - 選択したグループのインデックス
 */
const onSelectedGroup = (indexes: number[]) => {
  store.onSelectedGroup(indexes);
};

/**
 * 外すボタンを押した際の処理
 * @param value - 選択したグループ名
 */
const onUpdatedValue = (value: string[]) => {
  if (value.length === 0) {
    store.onSelectedDefaultValue();
  }
};

const useLabel = computed(() => (props.showLabel ? t('グループ') : ''));

/**
 * セレクトボックスをクリックした際の処理
 */
const onClickSelectInput = async () => {
  await store.reloadGroupData();
  state.value.selectInputState = true;
};

/**
 * セレクトボックスを閉じた際の処理
 */
const onClose = () => {
  state.value.selectInputState = false;
  emits('selectedGroups', state.value.selectedGroupIds);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultipleSelectInput, {
    index: _ctx.selectInputIndex,
    "selected-list": _unref(store).selectedGroupNames,
    placeholder: _unref(t)('グループ名'),
    label: useLabel.value,
    "filter-type": 'AGGREGATE_BUSINESS_GROUP',
    "use-reset": _ctx.useReset,
    "is-open-prop": _unref(state).selectInputState,
    "prop-options": _unref(store).groupListNames,
    "prop-paging-state": _unref(state).pagingState,
    "prop-paging-options": _unref(state).pagingOptions,
    "prop-selected-indexes": _unref(store).selectedIndexes,
    "use-teleport": _ctx.useTeleport,
    "onClick:selectInput": _cache[0] || (_cache[0] = () => onClickSelectInput()),
    onClose: _cache[1] || (_cache[1] = () => onClose()),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => onUpdatedValue(value)),
    "onUpdate:valueWithIndexes": _cache[3] || (_cache[3] = (_, indexes) => onSelectedGroup(indexes))
  }, null, 8, ["index", "selected-list", "placeholder", "label", "use-reset", "is-open-prop", "prop-options", "prop-paging-state", "prop-paging-options", "prop-selected-indexes", "use-teleport"]))
}
}

})